import * as React from "react";
import { type FC } from "react";
import { Gapped, Select } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { getUrbanSettlementItems } from "../FiasFnsManualEditorUtils";
import { Control } from "../controlsPaths";
import { AddressField } from "../AddressField";

interface SettlementProps {
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const controlType = Control.SettlementType;
const controlName = Control.SettlementName;

export const Settlement: FC<SettlementProps> = props => {
    const type = props.getValue(controlType);
    const urbanSettlementItems = getUrbanSettlementItems(type);
    const name = props.getValue(controlName);
    const onTypeChange = props.onChange(controlType);
    const onNameChange = props.onChange(controlName);

    return (
        <Row>
            <Caption>Поселение</Caption>
            <Gapped>
                <Select<string | undefined, string>
                    width={80}
                    placeholder={"Вид"}
                    data-tid={"SettlementType"}
                    value={type || undefined}
                    // @ts-expect-error Нужно сетить undefined для отображения placeholder-a
                    onValueChange={next => onTypeChange(next || undefined)}
                    items={urbanSettlementItems}
                />

                <AddressField
                    width={260}
                    maxLength={255}
                    value={name}
                    placeholder={"Наименование"}
                    data-tid={"SettlementName"}
                    onChange={onNameChange}
                />
            </Gapped>
        </Row>
    );
};
